<div class="c-modal c-modal--md" id="modal-{{vm.uid}}">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p style="font-size: 22px">{{ 'Survey_Selection.Description' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
					<form name="vm.form" class="c-form u-ost-md" (submit)="vm.preventNativeSubmit($event)" (ngSubmit)="vm.submit($event)">
						<div class="o-grid o-grid--wrap">
							<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
								<div *ngIf="vm.isPulseSurvey()" class="c-alert c-alert--info u-osb-lg" style="padding: 12px 14px; border-radius: 10px;">
									<p class="c-text c-text--bold">{{ 'Compliance_Assessment.Remeasure_Risk' | translate }}</p>
									<p class="c-text" style="margin-top: 6px;">{{ 'Compliance_Assessment.Pulse_Launch_Hint_Start' | translate }} {{ vm.pulseContext?.pulseRiskName || ('Compliance_Assessment.This_Compliance_Risk' | translate) }} {{ 'Compliance_Assessment.Pulse_Launch_Hint_End' | translate }}</p>
								</div>
								<div class="c-form__group u-osb-lg"
								[ngClass]="{ 'c-form__group--error': vm.submitted && !vm.selectedQuestionnaire }">
								<label for="targetPlatform" class="c-form__label c-form__label">
									{{ 'Services.Filter.Select_Survey' | translate }} *
								</label>
								<mat-select id="questionnaires" name="questionnaires" *ngIf="vm.questionnaires" class="mat-select mat-select--border" [(value)]="vm.selectedQuestionnaire" required>
									<mat-option id="questionnaire{{$index}}" *ngFor="let questionnaire of vm.questionnaires ; let $index=index" [value]="questionnaire">{{ vm.getQuestionnaireText(questionnaire) }}</mat-option>
									<mat-select-trigger>{{ vm.getQuestionnaireText(vm.selectedQuestionnaire) }}</mat-select-trigger>
								</mat-select>
							</div>
							<div class="c-form__group u-osb-lg">
								<label for="groupName" class="c-form__label c-form__label">{{ 'Surveys.Group_Label' | translate }}</label>
								<input
										id="groupName"
										name="groupNameInput"
										type="text"
										class="c-form__input c-form__input--sm" spellcheck="false"
										[(ngModel)]="vm.groupName">
							</div>
							<div class="c-form__group u-osb-lg"
								[ngClass]="{ 'c-form__group--error': vm.submitted && !vm.isDateRangeSelected() }">
								<label for="startTime" class="c-form__label c-form__label">{{ 'Services.Filter.Select_Start_End_Date' | translate }} *</label>
								<div id="surveyPeriod" *ngIf="vm.initialized">
									<input-datepicker-new 
										id="surveyPeriodDatePicker"
										name="startTime" 
										[(model)]="vm.dateRangeModel"
										[minDate]="vm.dateRangeMin" 
										data-el-parent="datePickerContainer"
										[hasTimepicker]="false" 
										[hasCalendarIcon]="false"
										[isSingleDate]="false" 
										[isRequired]="true">
									</input-datepicker-new>
								</div>
							</div>
							<div class="c-form__group u-osb-lg">
								<label for="languages" class="c-form__label c-form__label">
									{{ 'Services.Filter.Select_Language' | translate }}
								</label>
								<mat-select id="languages" name="languages" *ngIf="vm.languages" class="mat-select mat-select--border" [(value)]="vm.selectedLanguage">
									<mat-option id="language{{$index}}" *ngFor="let language of vm.languages ; let $index=index" [value]="language">{{ language.nativeName }}</mat-option>
								</mat-select>
							</div>
						</div>
					</div>
					<div class="c-panel u-no-p u-ost-sm u-osb-sm">
						<button
							type="submit"
							id="surveySubmitButton"
							[disabled]="vm.processing || !vm.initialized"
							class="c-button c-button--s2 c-button--narrow c-button--fit u-no-wrap">
							{{ 'Employees.Confirm' | translate }}
						</button>
					</div>
				</form>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
